import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, mappingResultError, Result, ValueObject } from '@digibricks/domains';
import { AudioFileNumberOfReplays } from './audio-file-number-of-replays';
export var AudioFileRule = /*#__PURE__*/function (_ValueObject) {
  _inherits(AudioFileRule, _ValueObject);

  var _super = _createSuper(AudioFileRule);

  function AudioFileRule() {
    _classCallCheck(this, AudioFileRule);

    return _super.apply(this, arguments);
  }

  _createClass(AudioFileRule, [{
    key: "numberOfReplays",
    get: function get() {
      return this.props.numberOfReplays;
    }
  }, {
    key: "isAutoPlay",
    get: function get() {
      return this.props.isAutoPlay;
    }
  }, {
    key: "allowingToPauseAndStop",
    get: function get() {
      return this.props.allowingToPauseAndStop;
    }
  }, {
    key: "isAllowedToReplay",
    get: function get() {
      return this.props.isAllowedToReplay;
    }
  }], [{
    key: "validate",
    value: function validate(props) {
      var guardCollection = [{
        argument: props.isAllowedToReplay,
        argumentName: 'Is Allowed To Replay'
      }, {
        argument: props.numberOfReplays,
        argumentName: 'Number of replays'
      }, {
        argument: props.isAutoPlay,
        argumentName: 'Is Auto Play'
      }, {
        argument: props.allowingToPauseAndStop,
        argumentName: 'Allowing To Pause And Stop'
      }, {
        argument: props.isAllowedToReplay,
        argumentName: 'Allowed To Replay'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "create",
    value: function create(props) {
      var validationResult = this.validate(props);

      if (validationResult.isFailure) {
        return mappingResultError(validationResult);
      }

      return Result.ok(new AudioFileRule(props));
    }
  }, {
    key: "createWithQuestion",
    value: function createWithQuestion(props) {
      var validationResult = this.validate(props);

      if (validationResult.isFailure) {
        return mappingResultError(validationResult);
      }

      var isAutoPlay = props.isAutoPlay,
          isAllowedToReplay = props.isAllowedToReplay,
          numberOfReplays = props.numberOfReplays;

      if (isAutoPlay) {
        return new BadInputError('The audio in question cannot auto play');
      }

      if (!isAllowedToReplay && !numberOfReplays.equals(AudioFileNumberOfReplays["default"])) {
        return new BadInputError('Number of replays should be default when not allowed to replay');
      }

      return Result.ok(new AudioFileRule(props));
    }
  }, {
    key: "createWithSectionOrSubSection",
    value: function createWithSectionOrSubSection(props) {
      return this.create(props);
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      var numberOfReplays = data.numberOfReplays,
          isAutoPlay = data.isAutoPlay,
          isAllowedToReplay = data.isAllowedToReplay,
          allowingToPauseAndStop = data.allowingToPauseAndStop;
      return this.create({
        numberOfReplays: AudioFileNumberOfReplays.create(numberOfReplays).getValue(),
        isAutoPlay: isAutoPlay,
        isAllowedToReplay: isAllowedToReplay,
        allowingToPauseAndStop: allowingToPauseAndStop
      });
    }
  }]);

  return AudioFileRule;
}(ValueObject);